import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PaymentTable = ({ className, ...props }) => (
  <div className={classnames('c-payment-table', className)} {...props} />
);
PaymentTable.propTypes = {
  className: PropTypes.string,
};
PaymentTable.defaultProps = {
  className: '',
};

const Row = ({ className, gray, ...props }) => (
  <div
    className={classnames('c-payment-table__row', className, { 'c-payment-table__row--gray': gray })}
    {...props}
  />
);
Row.propTypes = {
  className: PropTypes.string,
  gray: PropTypes.bool,
};
Row.defaultProps = {
  className: '',
  gray: false,
};
PaymentTable.Row = Row;

const Cell = ({ className, ...props }) => (
  <div className={classnames('c-payment-table__cell', className)} {...props} />
);
Cell.propTypes = {
  className: PropTypes.string,
};
Cell.defaultProps = {
  className: '',
};
PaymentTable.Cell = Cell;

export default PaymentTable;


